import { render } from "./App.vue?vue&type=template&id=1e605105"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1e605105&lang=less"
script.render = render

export default script